import { render } from "./CompanyInfo.vue?vue&type=template&id=4b377724&scoped=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=js"
export * from "./CompanyInfo.vue?vue&type=script&lang=js"

import "./CompanyInfo.vue?vue&type=style&index=0&id=4b377724&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b377724"]])

export default __exports__